export function getAPIToken(): string | null | undefined {
  const sessionData = JSON.parse(localStorage.getItem("sessionData") || "{}")
  return sessionData.token
}
